/**
 * Created by bvg on 23/07/2018.
 * Add class .date-picker to an inputfield to initialize it.
 */

$(document).ready(mDatePicker);

function mDatePicker () {
    if (Modernizr.inputtypes['date'] && checkMobile()) {
        //browser supports native date element -> input omzetten naar date
        $('input.date-picker[type=text]').each(function() {
            var R = { 'value': ['value', ''], 'data-date-start-date': ['min', null], 'data-date-end-date': ['max', null] };
            for(var attr in R) {
                $(this).attr(R[attr][0], datestr($(this).attr(attr) || null, R[attr][1]));
            }
            var defaultValue = datestr($(this).attr('data-date-default-view-date'), '');
            function datestr(val, defaultVal) {
                if(val==null) val = defaultVal;
                if(!val) return val;
                var part;
                if(part = val.match(/^(\d\d)-(\d\d)-(\d\d\d\d)$/))
                    return part[3]+'-'+part[2]+'-'+part[1];
                if(part = val.match(/^(\d\d\d\d)-(\d\d)-(\d\d)$/))
                    return val;
                if(part = val.match(/^(\d\d)\/(\d\d)\/(\d\d\d\d)$/))
                    return part[3]+'-'+part[1]+'-'+part[2];
                var d = new Date;
                if(val=='today') val ='+0d'; else if(val=='tomorrow') val ='+1d'; else if(val=='yesterday') val ='-1d';
                return val.replace(/([+-]\d+)([dmyw])/g, function(m, delta, unit) {
                    if(unit=='d') d.setDate(d.getDate()+ +delta);
                    else if(unit=='m') d.setMonth(d.getMonth()+ +delta);
                    else if(unit=='y') d.setYear(d.getYear()+ +delta);
                    else if(unit=='w') d.setDate(d.getDate()+7*+delta);
                    else return m;
                    return '' }).replace(/\s+/g, '')
                    ? val : (d.getYear()+1900)+'-'+(101+d.getMonth()+'').substr(-2)+'-'+(100+d.getDate()+'').substr(-2);
            }
            $(this).attr('type','date')
            .on('input', function() { // for iPad etc
                var err = false;
                if(this.value) {
                    if(err = this.min && this.value < this.min) this.value = '';
                    else if(err = this.max && this.max < this.value) this.value = '';
                }
                $(this).toggleClass('error', err);
            })
            .focus(function() { if(!this.value) this.value = defaultValue })
            .blur(function() { if(!this.value) this.value = '' })
        });
        return mDatePicker.datepicker = false;
    }
    else {
        if(!mDatePicker.datepicker) {
            $.extend($.fn.datepicker.defaults, {
                format: 'dd/mm/yyyy',
                autoclose: true,
                viewDate: false,
                todayHighlight: true,
                orientation: 'bottom',
                defaultViewDate: 'today',
                updateViewDate: false,
                templates: {
                    leftArrow: '<i class="fal fa-chevron-left"></i>',
                    rightArrow: '<i class="fal fa-chevron-right"></i>'
                }
            });
            for(var lang in $.fn.datepicker.dates) $.fn.datepicker.dates[lang].format = 'dd-mm-yyyy';
        }
        $('.date-picker:visible, input.custom-date-picker:visible').not('.input-daterange input').datepicker();
        $('.input-daterange:visible').each(function() { var $inputs = $(this).find('.date-picker:visible, input.custom-date-picker:visible'); $(this).datepicker({inputs: $inputs.toArray()})});
        return mDatePicker.datepicker = true;
    }
}